import { Box, Container, Typography, Grid, 
  FormControlLabel, Checkbox, Button, TextField, IconButton, Drawer } from '@mui/material';

import SimpleSelect from '../SimpleSelect';

import SimpleSelect2 from '../SimpleSelect2';

import * as React from 'react';
import {useEffect, useMemo} from 'react';
import { dateToDecimalHours, decimalToHoursAndMinutes, handlerOfMultipleSelectCheckmarksBy, useState } from '../Utils';
import {useAuth} from "../../contexts/AuthContext"

import {getLocations, handlerBy, makeCode, timeSlotString, weekDays, handlerOfCheckboxBy} from "../Utils"

import app from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';

import { useHistory } from 'react-router-dom';

import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import frLocale from 'date-fns/locale/fr';
import Iconify from '../Iconify';

import { SnackbarProvider, enqueueSnackbar } from 'notistack';
import { debugL } from '../../custom';
import { useCallback } from 'react';

import {
  parisZipOptions,
  parisCityOptions,
  zone2CityOptions,
  zone3CityOptions,
  zone2BCityOptions,
  offZoneCityOptions,
  cityZips,
  weightOptions,
  temperatureRangeOptions,
  tourHourOptions,
  tourMinuteOptions,
} from './OrderConstants.js';

import {
  delay,
  formatPrice,
  areDatesEqual,
  isDateInArray,
  getAllTimeSlots,
  computeTimeSlots,
  computeDays,
  computeLocationTimeSlots,
  computeLocationDays,
  computeTimeSlotHours,
  computeLocationTimeSlotHours,
  computeStartTimeOptions,
  computeLocationStartTimeOptions,
  computePickupTimeOptions,
  computeLocationPickupTimeOptions
} from './OrderUtils.js'; 

// import { cp } from 'fs';

const formatEtaRange = (etaString) => {
  if (!etaString || typeof etaString !== 'string' || !etaString.includes(':')) {
      return etaString; // Return original value if it's not a valid time string
  }
  const [hours, minutes] = etaString.split(':').map(Number);
  
  // Create a date object to perform time calculations
  const startTime = new Date(0);
  startTime.setHours(hours, minutes);

  // Add 15 minutes (15 * 60 * 1000 milliseconds)
  const endTime = new Date(startTime.getTime() + 15 * 60000);

  const endHours = String(endTime.getHours()).padStart(2, '0');
  const endMinutes = String(endTime.getMinutes()).padStart(2, '0');

  return `${etaString} - ${endHours}:${endMinutes}`;
};

const Timestamp = app.firestore.Timestamp;
const db = app.firestore();
const storage = app.storage();


const DebugComponent = React.memo(({handleTsRefresh, isRefreshTsProcessing, timeSlotType, setTimeSlotType, tsTypeOptions, 
  day, setDay, fullSupport, days, isStartTimeValid, startTime, setStartTime, startTimeOptions, freq, setFreq,
  recDailyDays, setRecDailyDays, recDefReady, setRecDefReady, isPickupTimeValid, pickupTime, setPickupTime, pickupTimeOptions,
  hightLightSx
}) => {

  debugL > 0 && console.log(">>>>>> RENDERING DEBUUUUUUUUUUUUUUUUUUUUUUUUUG");

  return (     
    <Grid item sm={12} xs={12} > debug </Grid>
  )
});

const OrderDescription = React.memo(({
  isTourMode,
  orderName, setOrderName, hasTemperatureRange, temperatureRange, setTemperatureRange,
  hasVoluminosity, voluminosity, setVoluminosity, 
  hasContainerReturn, containerReturn, setContainerReturn,
  hasInvoiceUnits, invoiceUnitsTitle, invoiceUnitsImplyWeight, 
  invoiceUnits, setInvoiceUnits, weight, setWeight, actualWeightOptions, weightPermissions,

  // --- Props for the multi-container system ---
  numberOfContainers,
  containerTitle1, containerCount1, setContainerCount1,
  containerTitle2, containerCount2, setContainerCount2,
  containerTitle3, containerCount3, setContainerCount3,
  containerTitle4, containerCount4, setContainerCount4,
  looseWeight, setLooseWeight
}) => { 

  debugL > 0 && console.log(">>>>>> RENDERING Order description");

  if (isTourMode) {
    // In Tour Mode, only show the order name field.
    return (
      <>
        <Grid item sm={12} xs={12} > <Typography color="textPrimary" variant="h6"> Description </Typography></Grid>
        <Grid item sm={12} xs={12} >
          <TextField
            value={orderName}
            onChange={handlerBy(setOrderName)}
            label="Référence de la commande"
            type="text"
            variant="outlined"
            fullWidth
          />
        </Grid>
      </>
    );
  }

  // --- SHARED LOGIC for Options (moved to top) ---
  // This logic is now common to both systems.
  const customerOptions = [];
  if(hasContainerReturn){
    customerOptions.push({value: "Retour Cont.", label : "Retour Cont."});
  }
  if(hasTemperatureRange) {
    customerOptions.push({value: "0°C-4°C", label :"0°C-4°C"});
  }
  if(hasVoluminosity){
    customerOptions.push({value: "Volume x 2", label : "Volume x 2"});
  }

  const orderOptions = [];
  if(temperatureRange=="0-4") { orderOptions.push("0°C-4°C") }
  if(voluminosity=="1") { orderOptions.push("Volume x 2") } 
  if(containerReturn=="1") { orderOptions.push("Retour Cont.") }

  const setOrderOptions = (options) => {
    console.log(options);
    setTemperatureRange(options.includes("0°C-4°C") ? "0-4" : "10-30");
    setVoluminosity(options.includes("Volume x 2") ? 1 : 0);
    setContainerReturn(options.includes("Retour Cont.") ? 1 : 0);
  }

  // --- SHARED UI for Options ---
  // We define the dropdown once to reuse it in both UIs.
  const optionsDropdown = (nColumns) => (hasTemperatureRange || hasVoluminosity || hasContainerReturn) ? (
    <Grid item md={nColumns} sm={6} xs={12}>
      <SimpleSelect
        value={orderOptions}
        onChange={handlerOfMultipleSelectCheckmarksBy(setOrderOptions)}
        label="Options"
        options={customerOptions}
        selectedOptions={orderOptions}
        renderValue={(selected) => selected.join(', ')}
        multiple
      />
    </Grid>
  ) : null;
  
  // --- Main conditional rendering ---
  if (numberOfContainers > 0) {
    // --- NEW multi-container system UI ---
    const definedContainers = [
      { title: containerTitle1, value: containerCount1, setter: setContainerCount1 },
      { title: containerTitle2, value: containerCount2, setter: setContainerCount2 },
      { title: containerTitle3, value: containerCount3, setter: setContainerCount3 },
      { title: containerTitle4, value: containerCount4, setter: setContainerCount4 },
    ].slice(0, numberOfContainers);

    const weightLineSize = 1 + numberOfContainers;

    return (
      <>
        <Grid item sm={12} xs={12} > <Typography color="textPrimary" variant="h6"> Description </Typography></Grid>
        <Grid item sm={6} md={9} xs={12} >
          <TextField
            value={orderName}
            onChange={handlerBy(setOrderName)}
            label="Référence de la commande"
            type="text"
            variant="outlined" 
            fullWidth
          />
        </Grid>
        
        {/* RENDER SHARED OPTIONS DROPDOWN */}
        {optionsDropdown(3)}

        {definedContainers.map((container, index) => (
          <Grid item sm={12/weightLineSize} xs={6} key={index}>
            <TextField 
              value={container.value} 
              onChange={handlerBy(container.setter)} 
              label={`Nbr. ${container.title}`} 
              type="number"
              inputProps={{
                min: "1",
                max: "100"
              }}
              variant="outlined" 
              fullWidth 
              required
              />
          </Grid>
        ))}

        <Grid item sm={12/weightLineSize} xs={6}>
          <SimpleSelect
            value={looseWeight}
            onChange={handlerBy(setLooseWeight, null, (weight) => {
                    // TODO verify if this applies to containers or only loose weight
                    let processedWeight = weight;
                    if (numberOfContainers > 0) {
                      processedWeight = 10;
                    }
                    if(processedWeight < 10 && (!weightPermissions || !weightPermissions.includes("S7H"))) {
                      enqueueSnackbar("Seuls les créneaux de l'après midi sont disponibles pour les tranches inférieures à 10 kg - 50 L", { variant: 'info', autoHideDuration: 5000 });  
                    }
                  })}
            label="Reste (Pds. Max - Vol. Max)"
            options={actualWeightOptions}
            required
          />
        </Grid>
      </>
    );
  }

  // --- ORIGINAL units-based system UI ---
  const headerSize = 1 + ((hasInvoiceUnits && invoiceUnitsImplyWeight)?0:1) + (hasInvoiceUnits?1:0) + (hasTemperatureRange || hasVoluminosity || hasContainerReturn ?1:0);

  return (
    <>
      <Grid item sm={12} xs={12} > <Typography color="textPrimary" variant="h6"> Description </Typography></Grid>
      <Grid item sm={6} xs={12} >
        <TextField
          value={orderName}
          onChange={handlerBy(setOrderName)}
          label="Référence de la commande"
          type="text"
          variant="outlined" 
          fullWidth
        />
      </Grid> 

      {/* RENDER SHARED OPTIONS DROPDOWN */}
      {optionsDropdown(6/(headerSize-1))}
      
      { (hasInvoiceUnits) ? 
        <Grid item sm={6/(headerSize-1)} xs={12} >
          <TextField
            value={invoiceUnits}
            onChange={handlerBy(setInvoiceUnits)}
            label={invoiceUnitsTitle ?? "Nombre d'unités"}
            type="number"
            inputProps={{
              min: "1",
              max: "270"
            }}
            variant="outlined" 
            fullWidth
          />
        </Grid> : null
      }
      { !(hasInvoiceUnits && invoiceUnitsImplyWeight) ?         
        <Grid item sm={6/(headerSize-1)} xs={12} >
          <SimpleSelect
            value={weight}
            onChange={handlerBy(setWeight, null, (weight) => {
                    if(weight < 10 && (!weightPermissions || !weightPermissions.includes("S7H"))) {
                      enqueueSnackbar("Seuls les créneaux de l'après midi sont disponibles pour les tranches inférieures à 10 kg - 50 L", { variant: 'info', autoHideDuration: 5000 });  
                    }
                  })}
            label="Poids (Max) - Volume (Max)"
            options={actualWeightOptions}
            required
          />
        </Grid> : null
      }
    </>
  )
});

const OrderTimeInfo = React.memo(({
  retailerOrderType, isTourMode, startHour, setStartHour, startMinute, setStartMinute,
  handleTsRefresh, isRefreshTsProcessing, timeSlotType, setTimeSlotType, tsTypeOptions, 
  day, setDay, fullSupport, days, isStartTimeValid, startTime, setStartTime, startTimeOptions, freq, setFreq,
  recDailyDays, setRecDailyDays, recDefReady, setRecDefReady, isPickupTimeValid, pickupTime, setPickupTime, pickupTimeOptions,
  hightLightSx
}) => {

  debugL > 0 && console.log(">>>>>> RENDERING ORDER TIME INFO");

  const datePickerItem = (
    <Grid item md={3} sm={6} xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
      <LocalizationProvider dateAdapter={AdapterDateFns} locale={frLocale}>
        <DesktopDatePicker
          label="Date"
          inputFormat="dd/MM/yyyy"              
          value={day}
          onChange={setDay}
          renderInput={
            (params) => <TextField 
              sx = {hightLightSx("day")} 
              fullWidth {...params} />
          }
          required
          // minDate={days[0] && !fullSupport ? days[0] : new Date(2024,0,1,6)}
          minDate={days[0] && !fullSupport ? days[0] : new Date(2024,0,1,6)}
          maxDate={days[0] ? days[days.length-1] : null}
          shouldDisableDate={function(date) { 
            // const disabledWeekDays = [0];
            // return disabledWeekDays.includes(date.getDay());
            return !isDateInArray(date, days);
          }}                      
        />
      </LocalizationProvider>
    </Grid>
  );

  if(retailerOrderType=="shopify-b2c") {
    return (
      <Grid item sm={12} xs={12} >
        <Box sx={{ display: 'flex', alignItems: "center"}} >
          <Typography color="textPrimary" variant="h6">
            {"(Créneau horaire de livraison choisi par le client)"}
          </Typography>
        </Box>
      </Grid>
    )
  } 

  else {
    return ( <>    
      <Grid item sm={12} xs={12} >
      <Box sx={{ display: 'flex', alignItems: "center"}} >
        <Typography color="textPrimary" variant="h6">
          {"Créneau horaire de livraison"}
        </Typography>
        <Box pr={2}></Box>
        <IconButton onClick={() => handleTsRefresh()}  disabled={isRefreshTsProcessing}>
          <Iconify icon={"eva:refresh-fill"} style={{ color: isRefreshTsProcessing ? 'gray' : '#357be4' }}/>
        </IconButton>
      </Box>
      </Grid>

      {isTourMode ? (
        // --- NEW: TOUR MODE TIME SELECTION ---
        <>
          {datePickerItem}
          <Grid item md={3} sm={6} xs={12}>
            <SimpleSelect
              value={startHour}
              onChange={handlerBy(setStartHour)}
              label="Heure de départ"
              options={tourHourOptions}
              />
          </Grid>
          <Grid item md={3} sm={6} xs={12}>
            <SimpleSelect
              value={startMinute}
              onChange={handlerBy(setStartMinute)}
              label="Minute"
              options={tourMinuteOptions}
              />
          </Grid>
        </>
      ) : (
        <>
          <Grid item md={3} sm={6} xs={12} sx={{ display: 'flex', alignItems: 'center'}}>          
            <SimpleSelect
              value={timeSlotType}
              onChange={handlerBy(setTimeSlotType)}
              labelId="ts-label"
              label="Type du créneau"
              options={tsTypeOptions}
            />
          </Grid>
          {datePickerItem}
          <Grid item md={3} sm={6} xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
            <SimpleSelect
              color={isStartTimeValid ? "primary" : "warning"}
              value={startTime}
              onChange={handlerBy(setStartTime)}
              labelId="ts-label"
              label="Créneau de livraison"
              options={startTimeOptions}
              sx={hightLightSx("startTime")}
            />
          </Grid>
        </>
      )}

      <Grid item md={3} sm={6} xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
        <SimpleSelect
          value={freq}
          onChange={handlerBy(setFreq)}
          labelId="freq-label"
          label="Fréquence"            
          options={[
            {label: 'Unique', value: 'unique'},
            {label: 'Mensuelle', value: 'monthly'},
            {label: 'Bihebdomadaire', value: 'biweekly'},
            {label: 'Hebdomadaire', value: 'weekly'},
            {label: 'Quotidienne', value: 'daily'}
          ]}
        />
      </Grid>
      {freq=="daily" && <Grid item md={12} sm={12} xs={12} >
        {["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"].map((day, index) =>
          <FormControlLabel label={day} control={<Checkbox 
            checked={recDailyDays.charAt(index)=="1"?true:false}
            onChange={handlerOfCheckboxBy((val)=>{
              const oldStr = recDailyDays;
              console.log(oldStr);
              const newStr = recDailyDays.replaceAt(index, val==true?"1":"0");
              console.log(newStr);
              setRecDailyDays(newStr);                        
            })}
          />} />
        )}
      </Grid>}
      {freq!="unique" && <Grid item md={12} sm={12} xs={12} >
        <FormControlLabel label='Automatiquement marquer les prochaines livraisons avec le statut "Prête"' control={<Checkbox 
          checked={recDefReady}
          onChange={handlerOfCheckboxBy(setRecDefReady)}
        />} />
      </Grid>} 
      {!isTourMode && (    
        <>               
          <Grid item sm={12} xs={12} >
            {/* <Box sx={{ display: 'flex', alignItems: "center", pr: 3}}> */}
            <Box sx={{ display: 'inline-flex', alignItems: "center"}} >
              <Typography noWrap variant="subtitle1">
                {"Enlèvement possible à partir de"}
              </Typography>
              <Box sx={{ display: 'inline-flex', ml: 2, width: 100 }} >
                <SimpleSelect
                  color={isPickupTimeValid ? "primary" : "warning"}
                  value={pickupTime}
                  onChange={handlerBy(setPickupTime)}
                  labelId="ts-label"
                  label=""
                  options={pickupTimeOptions}
                  sx = {hightLightSx("pickupTime")}
                />
              </Box>
            </Box>
          </Grid>
          {(!isStartTimeValid || !isPickupTimeValid) && <Grid item md={12} sm={12} xs={12} >
            <Typography variant="subtitle1" sx={{color: "#FFB020"}}>
              {"Attention ! Les horaires choisis ne respectent pas le paramètrage des boutiques"}
            </Typography>                  
          </Grid>}
        </>
      )}


    </>);
  }
});

OrderTimeInfo.whyDidYouRender = true;

const OrderCard = ({isUpdate, orderId, setLastRefreshDate, fullSupport, drawerTitle, drawerState, toggleDrawer, isMobile, ...rest}) => {
  const history = useHistory()

  const tsTypeOptionsFull= [
    { label: "3H (B2B)",       value: "3" },
    { label: "2H (B2B)",       value: "2" },
    { label: "1H (B2C & B2B)", value: "1" },
    { label: "Express",        value: "0" },
  ]

  // STATES and CUSTOM SETTERS

  const [tsTypeOptions, setTsTypeOptions] = useState(tsTypeOptionsFull, "tsTypeOptions");
  
  const [orderName, setOrderName] = useState("", "orderName");
  const [invoiceUnits, setInvoiceUnits] = useState(1, "invoiceUnits");
  const [containerCount1, setContainerCount1] = useState(0, "containerCount1");
  const [containerCount2, setContainerCount2] = useState(0, "containerCount2");
  const [containerCount3, setContainerCount3] = useState(0, "containerCount3");
  const [containerCount4, setContainerCount4] = useState(0, "containerCount4");
  const [looseWeight, setLooseWeight]         = useState("10", "looseWeight");
  

  const [temperatureRange, setTemperatureRange] = useState("10-30", "temperatureRange");
  const [voluminosity, setVoluminosity] = useState(0, "voluminosity");
  const [containerReturn, setContainerReturn] = useState(0, "containerReturn");
  const [retailerOrderType, setRetailerOrderType] = useState(0, ""); // can be used for many options. if not empty set the retailerOrderType.
  const [weight, setWeight] = useState("10", "weight");

  const [cityOptions, setCityOptions] = useState(parisCityOptions, "cityOptions");
  const [cityZipOptions, setCityZipOptions] = useState(parisZipOptions, "cityZipOptions");
  const [city, setCity] = useState("Paris", "city");
  const [address, setAddress] = useState("", "address");
  const [zipCode, setZipCode] = useState("75001", "zipCode");
  const [company, setCompany] = useState("", "company");
  const [firstName, setFirstName] = useState("", "firstName");
  // const [lastName, setLastName] = useState("", "const");
  const [phoneNumber, setPhoneNumber] = useState("", "phoneNumber");
  const [instructions, setInstructions] = useState("", "instructions");
  
  const [cityOptions0, setCityOptions0] = useState(parisCityOptions, "cityOptions");
  const [cityZipOptions0, setCityZipOptions0] = useState(parisZipOptions, "cityZipOptions");
  const [city0, setCity0] = useState("Paris", "city");
  const [address0, setAddress0] = useState("", "address0");
  const [zipCode0, setZipCode0] = useState("75001", "zipCode0");
  const [company0, setCompany0] = useState("", "company0");
  const [firstName0, setFirstName0] = useState("", "firstName0");
  // const [lastName0, setLastName0] = useState("", "const");
  const [phoneNumber0, setPhoneNumber0] = useState("", "phoneNumber0");
  const [instructions0, setInstructions0] = useState("", "instructions0");
  
  const [allTimeSlots, setAllTimeSlots] = useState([], "allTimeSlots");

  // const [timeSlots, setTimeSlots] = useState([], "const");
  // const [locationTimeSlots, setLocationTimeSlots] = useState([], "const");

  const [timeSlotType, _setTimeSlotType] = useState("3", "timeSlotType");
  const [day, _setDay] = useState(new Date(), "day");

  const disableStartTimeAndPickupChecks = () => {
    setIsStartTimeCheck(false);
    debugL > 1 && console.log("setIsStartTimeCheck(false)");
    setIsPickupTimeCheck(false);
    debugL > 1 && console.log("setIsPickupTimeCheck(false)");
  }
  const setTimeSlotType = useCallback((newVal) => {
    if(newVal != timeSlotType) {
      disableStartTimeAndPickupChecks();
      _setTimeSlotType(newVal);
    }
  }, [timeSlotType])

  const setDay = useCallback((newVal) => {
    if(!areDatesEqual(day, newVal)) {
      disableStartTimeAndPickupChecks();
      _setDay(newVal);
    }
  }, [day]);

  const [startTime, _setStartTime] = useState("", "startTime");
  const [isStartTimeCheck, setIsStartTimeCheck] = useState(false, "isStartTimeCheck");

  const setStartTime = useCallback((newVal) => {
    if(startTime != newVal) {
      setIsPickupTimeCheck(false);
      debugL > 1 && console.log("setIsPickupTimeCheck(false)");
      _setStartTime(newVal);
    }
  }, [startTime]);

  const [pickupTime, setPickupTime] = useState("", "pickupTime");
  const [isPickupTimeCheck, setIsPickupTimeCheck] = useState(false, "isPickupTimeCheck");

  const [highlightedInputs, setHighlightedInputs] = useState([], "highlightedInputs");
  
  // const [recurrent, setRecurrent] = useState(false, "const");
  const [freq, setFreq] = useState("unique", "freq");
  const [recDefReady, setRecDefReady] = useState(false, "recDefReady");
  const [recDailyDays, setRecDailyDays] = useState("1111111", "recDailyDays");

  // const [freqDays, setFreqDays] = useState("1", "const");
  const [locations, setLocations] = useState([], "locations");
  const [defaultPickup, setDefaultPickup] = useState(true, "defaultPickup");
  const [locationIndex, _setLocationIndex] = useState("", "locationIndex");

  const setLocationIndex = (newVal) => {    
    if(locationIndex != newVal) {
      disableStartTimeAndPickupChecks();
      _setLocationIndex(newVal);
    }
  }

  const [deliveryLocationIndex, _setDeliveryLocationIndex] = useState("", "deliveryLocationIndex");

  const setDeliveryLocationIndex = (newVal) => {
    if(deliveryLocationIndex != newVal) {
      disableStartTimeAndPickupChecks();
      _setDeliveryLocationIndex(newVal);
    }
  }
  
  const [shippingPrice, setShippingPrice] = useState('-.--', "shippingPrice");

  
  const [cachedOrder, setCachedOrder] = useState(null, "cachedOrder");
  
  const [newOrderId, setNewOrderId] = useState("", "newOrderId");
  
  const {retailerId, retailerData, retailerFallbackLocationId, isDeliveryNoteMendatory, currentUser} = useAuth();

  // const [deliveryNoteUpload, setDeliveryNoteUpload] = useState(null, "const");
  const [deliveryNotePath, setDeliveryNotePath] = useState("", "deliveryNotePath");

  const [isConfirmProcessing, setIsConfirmProcessing] = useState(false, "isConfirmProcessing");
  const [isUploadProcessing, setIsUploadProcessing] = useState(false, "isUploadProcessing");
  const [isRefreshTsProcessing, setIsRefreshTsProcessing] = useState(false, "isRefreshTsProcessing");

  // The master flag to enable Tour Mode UI and logic.
  const isTourMode = retailerData.pricingMode?.includes("2024c");

  // State for managing the list of action points in the tour.
  const [actionPoints, setActionPoints] = useState([
    { id: 1, city: "Paris", zipCode: "75001", address: "", company: "", firstName: "", phoneNumber: "", instructions: "", serviceTime: 5 },
    { id: 2, city: "Paris", zipCode: "75001", address: "", company: "", firstName: "", phoneNumber: "", instructions: "", serviceTime: 5 },
  ]);

  // State to hold the calculated results.
  const [tourDuration, setTourDuration] = useState(null);
  const [pointEtas, setPointEtas] = useState([]);

  const [startHour, setStartHour] = useState(9);
  const [startMinute, setStartMinute] = useState(0);

  // INTERNAL METHODS

  const fixedDay = (curDay = day) => {    
    let newDay = null;

    // console.log(days.length);
    // console.log(locationDays.length);

    if(locationDays.length > 0) {
      if(isDateInArray(curDay, locationDays)) {
        // do nothing 
      } else {
        newDay = locationDays[0];
      }
    } else if (days.length > 0) {
      if(isDateInArray(curDay, days)) {
        // do nothing 
      } else {
        newDay = days[0];
      }
    }

    // console.log("day", day);
    debugL > 1 && newDay && console.log("DDDDDDDDDDDDDDDDDDDDDDDDDD fixed newDay", newDay);
    return newDay;
  }

  const fixedStartTime = () => {
    const startTimes = startTimeOptions.map(option => option.value);
    const locationStartTimes = locationStartTimeOptions.map(option => option.value);
    
    let newStartTime = null;

    // console.log("cachedOrder", cachedOrder);
    // cachedOrder && console.log("areDatesEqual(cachedOrder.timeSlot, day)", areDatesEqual(cachedOrder && cachedOrder.timeSlot.toDate(), day));
    // cachedOrder && console.log("cachedOrder.startTime", cachedOrder.timeSlot.toDate().getHours(), startTime);
    // cachedOrder && console.log("startTimes.includes(startTime)", startTimes.includes(startTime));

    if(cachedOrder && cachedOrder.timeSlot && areDatesEqual(cachedOrder.timeSlot.toDate(), day) && 
        cachedOrder.timeSlot.toDate().getHours() == startTime && 
        startTimes.includes(startTime)) {
      // do nothing
    } else {
      if(locationStartTimes.length > 0) {
        if(locationStartTimes.includes(startTime)) {
          // do nothing 
        } else {
          newStartTime = locationStartTimes[0];
        }
      } else if (startTimes.length > 0) {
        if(startTimes.includes(startTime)) {
          // do nothing 
        } else {
          newStartTime = startTimes[0];
        }
      } else {
        newStartTime = "";      
      }
    }    

    debugL > 1 && newStartTime && console.log("SSSSSSSSSSSSSSSSSSSSSSSSSSS fixed StartTime", newStartTime);
    return newStartTime
  }

  const fixedPickupTime = () => {
    const pickupTimes = pickupTimeOptions.map(option => option.value);
    const locationPickupTimes = locationPickupTimeOptions.map(option => option.value);

    // console.log("locationPickupTimes");
    // console.log(locationPickupTimes);
    
    // console.log("pickupTimes");
    // console.log(pickupTimes);

    // console.log("pickupTime");
    // console.log(pickupTime);

    let newPickupTime = null;

    if(cachedOrder && cachedOrder.timeSlot && areDatesEqual(cachedOrder.timeSlot.toDate(), day) && 
        cachedOrder.timeSlot.toDate().getHours() == startTime && 
        cachedOrder.pickupTime == pickupTime) {
      // do nothing
    } else {
      if(locationPickupTimes.length > 0) {
        if(locationPickupTimes.includes(pickupTime)) {
          // do nothing 
        } else {
          newPickupTime = locationPickupTimes[0];
        }
      } else if (startTime) {
        if (pickupTime == startTime) {
          // do nothing 
        } else {
          // console.log(startTime);
          // console.log(newPickupTime);

          newPickupTime = startTime;
        }
        
      } else {
        newPickupTime = "";
      }
    }
    
    debugL > 1 && newPickupTime && console.log("PPPPPPPPPPPPPPPPPPPPPPPPPPP fixed PickupTime", newPickupTime)
    return newPickupTime;
  };

  const resetDay = () => {
    const dayZero = new Date(0);

    let resetDay = dayZero;

    const newDay = fixedDay(dayZero);
    
    if(newDay) {
      resetDay = newDay;
    }
    
    setStartTime("");    
    if(!areDatesEqual(day, resetDay)) {
      // console.log("A day", day, "resetDay", resetDay);
      setDay(resetDay);
      setTemporaryInputHighlight("day");
    } else {
      // needed just to trigger the useEffect that fixes startTime when day has changed.
      const sameDay = new Date(resetDay);
      // console.log("B day", day, "resetDay", sameDay);
      _setDay(sameDay);  
    }
  }

  const hightLightSx = useCallback((name) => ({
    backgroundColor: highlightedInputs.includes(name) ? '#e3f2fd' : 'inherit',
    transition: 'background-color 0.5s ease',
  }), [highlightedInputs]);

  const setTemporaryInputHighlight = (name) => {
    setHighlightedInputs((prevHighlighted) => [...prevHighlighted, name]);
    setTimeout(() => {
      setHighlightedInputs((prevHighlighted) =>
        prevHighlighted.filter((input) => input !== name)
      );
    }, 1000);
  }

  const timeSlotfromStartTime = () => {
    const ts = day;

    // console.log(startTime);
    const [optionHours, optionMinutes] = decimalToHoursAndMinutes(startTime);

    // console.log(optionHours);
    // console.log(optionMinutes);
    
    ts.setHours(optionHours);
    ts.setMinutes(optionMinutes);
    ts.setSeconds(0);
    
    return ts;
  }

  const validate = async () => {

    // TIMESLOT VALIDATION
    if(timeSlotType != "0" && !fullSupport) {
      const ts = timeSlotfromStartTime();
      ts.setMinutes(0);
  
      const timestamp = Timestamp.fromDate(ts);
      const results = await db.collection('timeSlots').where("startTime", "==", timestamp).where("status", "==", "open").get();
      
      // console.log("results.docs.length " + results.docs.length);
  
      if (results.docs.length !== 1) {
        updateAllTimeSlots();
        enqueueSnackbar("Le créneau choisi n'est plus disponible !", { variant: 'error', autoHideDuration: 3000 });
        throw new Error("Time Slot is not valid (anymore)");
      }

      // TIMESLOT VALIDATION FOR HUB
      if(locations[locationIndex].id == "HUB") {
        // Get the current date and time
        const now = new Date();

        // Create a date object for 4:00 PM today
        const fourPMToday = new Date();
        fourPMToday.setHours(16, 0, 0, 0); // 16 represents 4:00 PM

        // Create a date object for 1:00 PM tomorrow
        const onePMTomorrow = new Date();
        onePMTomorrow.setDate(now.getDate() + 1);
        onePMTomorrow.setHours(12, 0, 0, 0); // 13 represents 1:00 PM

        // Check the condition:
        // Is it currently after 4 PM today AND is the input date before 1 PM tomorrow?

        if (now > fourPMToday && ts < onePMTomorrow) {
          enqueueSnackbar("Les commandes du matin au départ du HUB doivent être passées avant 16h.", { variant: 'error', autoHideDuration: 3000 });
          throw new Error("Time Slot is not valid for HUB (anymore)");
        }
      }
    }
  }

  const handleTsRefresh = useCallback(async () => {
    setIsRefreshTsProcessing(true);    
    await updateAllTimeSlots(); 
    setIsRefreshTsProcessing(false);
  }, []);

  const swapPikcupAndDelivery = async () => {
  
    setCity(city0)
    setAddress(address0);
    setZipCode(zipCode0);
    setCompany(company0);
    setFirstName(firstName0);
    setPhoneNumber(phoneNumber0);
    setInstructions(instructions0);

    setCity0(city)
    setAddress0(address);
    setZipCode0(zipCode);
    setCompany0(company);
    setFirstName0(firstName);
    setPhoneNumber0(phoneNumber);
    setInstructions0(instructions);

    setLocationIndex(deliveryLocationIndex);
    setDeliveryLocationIndex(locationIndex);

  }

  const resetForm = () => {
    setCachedOrder(null);
    setOrderName("");
    setInvoiceUnits(1);
    setContainerCount1(0);
    setContainerCount2(0);
    setContainerCount3(0);
    setContainerCount4(0);
    setLooseWeight("10");
    setTemperatureRange("10-30")
    setVoluminosity(0);
    setContainerReturn(0);
    setRetailerOrderType("");
    setWeight("10");
    setAddress("");
    setCity("Paris");
    setZipCode("75001");
    setCompany("");
    setFirstName("");
    setPhoneNumber("");
    setInstructions("");
    setAddress0("");
    setCity0("Paris");
    setZipCode0("75001");
    setCompany0("");
    setFirstName0("");
    setPhoneNumber0("");
    if(locations.length>0) {
      setLocationIndex("0");
      setDeliveryLocationIndex("" + (locations.length-1));
    }
    setInstructions0("");
    setTimeSlotType("3");
    resetDay();
    debugL > 1 && console.log("===> resetForm - resetDay invoked ");
    setFreq("unique");
    setRecDefReady(false);
    setRecDailyDays("1111111");
    setDefaultPickup(true);
    setShippingPrice('-.--');
    setNewOrderId("");
    setDeliveryNotePath("");
    setIsConfirmProcessing(false);
    setIsUploadProcessing(false);

    // reset state for managing the list of action points in the tour.
    setActionPoints([
      { id: 1, city: "Paris", zipCode: "75001", address: "", company: "", firstName: "", phoneNumber: "", instructions: "", serviceTime: 5 },
      { id: 2, city: "Paris", zipCode: "75001", address: "", company: "", firstName: "", phoneNumber: "", instructions: "", serviceTime: 5 },
    ]);
    setTourDuration(null);
    setPointEtas([]);

    setStartHour(9);
    setStartMinute(0);
  }

  const uploadDeliveryNote = async (deliveryNoteUpload) => {

    // console.log(deliveryNoteUpload);

    if(deliveryNoteUpload == null) {
      console.log("deliveryNoteUpload is null");
      return;
    }

    setIsUploadProcessing(true);

    const path = "deliveryNotes/" + makeCode(8) + "_" + deliveryNoteUpload.name  
    // console.log(path);
    
    const noteRef = storage.ref(path);

    try{
      await noteRef.put(deliveryNoteUpload);
      setDeliveryNotePath(path);
    }
    catch (error) {
      console.log(error);
      setDeliveryNotePath("L'upload du bon de livraison a échoué");
    }
    finally {
      setIsUploadProcessing(false);
    }
  } 

  const updateAllTimeSlots = async (forceReset = true) => {
    const allTimeSlots = (await getAllTimeSlots());
    debugL > 1 && console.log("===> updateAllTimeSlots - allTimeSlots loaded");
    setAllTimeSlots(allTimeSlots);
    debugL > 1 && console.log("===> updateAllTimeSlots - allTimeSlots set");
    if(allTimeSlots.length > 0 && (!orderId || forceReset)) {
      // setDay(allTimeSlots[0].startTime.toDate());
      // setDay(new Date());
      resetDay();
      debugL > 1 && console.log("===> updateAllTimeSlots - resetDay invoked");
    }
  }

  const prefillPickupAddress = async () => {

    const locationId = locations[parseInt(locationIndex)].id;

    const location = (await db.collection('locations').doc(locationId).get()).data();

    console.log(location);

    setAddress0(location.address.streetAddress);
    setCity0(location.address.city);
    setZipCode0(location.address.zipCode);
    setCompany0(location.name);
    setInstructions0(location.address.instructions);
    setFirstName0(location.contact.firstName);
    setPhoneNumber0(location.contact.phoneNumber);

    setLocationIndex("" + (locations.length-1));

  }

  const prefillDeliveryAddress = async () => {

    const locationId = locations[parseInt(deliveryLocationIndex)].id;

    const location = (await db.collection('locations').doc(locationId).get()).data();

    console.log(location);

    setAddress(location.address.streetAddress);
    setCity(location.address.city);
    setZipCode(location.address.zipCode);
    setCompany(location.name);
    setInstructions(location.address.instructions);
    setFirstName(location.contact.firstName);
    setPhoneNumber(location.contact.phoneNumber);

    setDeliveryLocationIndex("" + (locations.length-1));

  }

  const fillPickupAddress = async (updateDoc, locationId) => {

    // TODO once external is implemented, this if condition could also be explicit as :
    // if(["HUB", "EXTERNAL"].includes(locationId)) {
    if(!updateDoc.pickupAddress) {
        const retailer = (await db.collection('retailers').doc(retailerId).get()).data();

        if(!locationId) {
            locationId = retailer.fallbackLocationId;            
            updateDoc.locationId = locationId;
        }

        if(!locationId) {
            throw Error("No Pickup Address and No locationId !!");
        } else {
            const location = (await db.collection('locations').doc(locationId).get()).data();
    
            // add pickupAdress
            updateDoc.pickupAddress = {
                address1: location.address.streetAddress,
                city: location.address.city,
                country: location.address.country,
                postcode: location.address.zipCode,
                company: location.name ?? retailer.name ?? "",
                firstName: location.contact.firstName??"" + " " + location.contact.lastName??"",
                phoneNumber: location.contact.phoneNumber,
                instructions: "",
            }
        }
    }

    debugL > 1 && console.log("cartUpdate after fill pickup Adress");
    debugL > 1 && console.log(updateDoc);
  }

  const fillDeliveryAddress = async (updateDoc, deliveryLocationId) => {
    const retailer = (await db.collection('retailers').doc(retailerId).get()).data();

    // TODO once external is implemented, this if condition could also be explicit as :
    // if(["HUB", "EXTERNAL"].includes(deliveryLocationId)) {
    if(!updateDoc.customerAddress) {
        if(!deliveryLocationId) {
            throw Error("No Customer Address and no deliveryLocationId !!");
        } else {
            const location = (await db.collection('locations').doc(deliveryLocationId).get()).data();
    
            // add pickupAdress
            updateDoc.customerAddress = {
                address1: location.address.streetAddress,
                city: location.address.city,
                country: location.address.country,
                postcode: location.address.zipCode,
                company: location.name ?? retailer.name ?? "",
                firstName: location.contact.firstName??"" + " " + location.contact.lastName??"",
                phoneNumber: location.contact.phoneNumber,
                instructions: "",
            }
        }
    }

    debugL > 1 && console.log("cartUpdate after fill customer Adress");
    debugL > 1 && console.log(updateDoc);
  }

  // --- Handlers for Managing Action Points ---
  const handlePointChange = (index, field, value) => {
    const updatedPoints = [...actionPoints];
    updatedPoints[index][field] = value;
    setActionPoints(updatedPoints);
  };

  const addPoint = () => {
    if (actionPoints.length < 10) {
      setActionPoints([
        ...actionPoints,
        { id: actionPoints.length + 1, city: "Paris", zipCode: "75001", address: "", company: "", firstName: "", phoneNumber: "", instructions: "", serviceTime: 5 },
      ]);
    }
  };

  const removePoint = (index) => {
    if (actionPoints.length > 2) {
      const updatedPoints = actionPoints.filter((_, i) => i !== index);
      setActionPoints(updatedPoints);
    }
  };

  // RENDERIN START

  // debugL > 0 && console.log("\n>> STATE =>", "Exp", locationIndex, "Dst", deliveryLocationIndex, 
  //   "D", day.toLocaleDateString(), "T"+timeSlotType, "S", startTime, "P", pickupTime);

  // MEMOIZED VALUES

  const allRetailerPermissions = {
    timePermissions   : retailerData.timePermissions,
    timePermissions2H : retailerData.timePermissions2H,
    timePermissions3H : retailerData.timePermissions3H,
    weightPermissions : retailerData.weightPermissions, // S7H means the retailer can make small orders (< 10kg) since 7H.
  } 

  const timeSlots = useMemo(() => {
    return computeTimeSlots(allTimeSlots, weight, city, timeSlotType, fullSupport, allRetailerPermissions);
  }, [allTimeSlots, weight, city, timeSlotType]); 

  const days = useMemo(() => {
    return computeDays(timeSlots);
  }, [timeSlots]); 

  const location = useMemo(() => {
    return locationIndex && locations && locations.length > locationIndex ? locations[parseInt(locationIndex)].location : null;
  }, [locationIndex, locations]);

  const deliveryLocation = useMemo(() => {
    return deliveryLocationIndex && locations && locations.length > deliveryLocationIndex ? locations[parseInt(deliveryLocationIndex)].location : null;
  }, [deliveryLocationIndex, locations]);

  const locationTimeSlots = useMemo(() => {    
    debugL > 1 && console.log("LLLLLLLLLLLLLLLLLLLLLLLL", locationIndex, deliveryLocationIndex);
    debugL > 1 && console.log(location);
    debugL > 1 && console.log(deliveryLocation);

    return computeLocationTimeSlots(timeSlots, [location, deliveryLocation]);
  }, [timeSlots, locationIndex, deliveryLocationIndex, locations]);

  const pickupLocationTimeSlots = useMemo(() => {    
    return computeLocationTimeSlots(timeSlots, [location]);
  }, [timeSlots, locationIndex, locations]);

  const locationDays = useMemo(() => {
    return computeLocationDays(locationTimeSlots);
  }, [locationTimeSlots]); 

  const timeSlotHours = useMemo(() => {
    // console.log("before calling computeTimeSlotHours - timeSlots :")
    // console.log(timeSlots);
    return computeTimeSlotHours(timeSlots, day);
  }, [timeSlots, day]); 
  
  const locationTimeSlotHours = useMemo(() => {
    return computeLocationTimeSlotHours(timeSlotHours, [location, deliveryLocation], day);
  }, [locationTimeSlots, day]); 

  const pickupLocationTimeSlotHours = useMemo(() => {
    return computeLocationTimeSlotHours(timeSlotHours, [location], day);
  }, [locationTimeSlots, day]);

  const startTimeOptions = useMemo(() => {    
    return computeStartTimeOptions(timeSlotHours, timeSlotType, allRetailerPermissions);
  }, [timeSlotHours, timeSlotType]); 

  const locationStartTimeOptions = useMemo(() => {
    return computeLocationStartTimeOptions(startTimeOptions, locationTimeSlotHours, timeSlotType);
  }, [startTimeOptions, locationTimeSlotHours]); 

  const pickupTimeOptions = useMemo(() => {
    return computePickupTimeOptions(timeSlotHours, startTime);    
  }, [timeSlotHours, startTime]) 

  const locationPickupTimeOptions = useMemo(() => {
    return computeLocationPickupTimeOptions(pickupTimeOptions, pickupLocationTimeSlotHours);
    
    // const pickupTimes = pickupTimeOptions.map(option => option.value);
    // const locationPickupTimes = newLocationPickupTimeOptions.map(option => option.value);

    // console.log("locationPickupTimes");
    // console.log(locationPickupTimes);
    
    // console.log("pickupTimes");
    // console.log(pickupTimes);

    // console.log("pickupTime");
    // console.log(pickupTime);
    
  }, [pickupTimeOptions, pickupLocationTimeSlotHours]); // => updated locationPickupTimeOptions and pickuptime if needed

  const isStartTimeValid = useMemo(() => {
    // await new Promise(resolve => setTimeout(resolve, 1000));
    debugL > 1 && console.log("startTime", startTime);
    let isValid = false;

    if(!isStartTimeCheck) {
      isValid = true;
    } else {
      const locationStartTimes = locationStartTimeOptions.map(option => option.value);
  
      if(locationStartTimes.includes(startTime) || startTime == "") {
        isValid = true;     
      }
    }

    debugL > 1 && console.log("isValid startTime",isValid);
    return isValid; 
  }, [locationStartTimeOptions, startTime, isStartTimeCheck]); // => isStartTimeValid
  
  const isPickupTimeValid = useMemo(() => {
    // await new Promise(resolve => setTimeout(resolve, 1000));
    debugL > 1 && console.log("pickupTime", pickupTime);
    let isValid = false;

    if(!isPickupTimeCheck) {
      isValid = true;
    } else {
      const locationPickupTimes = locationPickupTimeOptions.map(option => option.value);
      
      if(locationPickupTimes.includes(pickupTime) || pickupTime == "") {
        isValid = true;     
      } 
    }
    
    debugL > 1 && console.log("isValid pickupTime",isValid);
    return isValid;
  }, [locationPickupTimeOptions, pickupTime, isPickupTimeCheck]) // => isPickupTimeValid
  
  // SIDE EFFECTS
  
  debugL > 0 && useEffect(() => {
    debugL > 0 && console.log(">> STATE =>", "Exp", locationIndex, "Dst", deliveryLocationIndex, 
      "D", day.toLocaleDateString(), "T"+timeSlotType, "S", startTime, "P", pickupTime);

    debugL > 0 && console.log("MEMOIZED => ", locationTimeSlots.length, startTimeOptions.map(o => o.value), isStartTimeCheck, isStartTimeValid, 
      pickupTimeOptions.map(o => o.value), isPickupTimeCheck, isPickupTimeValid, highlightedInputs, "\n  ");
  });
    
    
  useEffect(() => {
    const newPickupTime = fixedPickupTime();
    if(newPickupTime) {
      setPickupTime(newPickupTime);
      setTemporaryInputHighlight("pickupTime");
    }
    setIsPickupTimeCheck(true);
    debugL > 1 && console.log("setIsPickupTimeCheck(true)");
  }, [pickupTimeOptions, locationTimeSlotHours, startTime]); // fixes pickupTime

  useEffect(() => {
    const newStartTime = fixedStartTime();
    if(newStartTime) {
      setStartTime(newStartTime);
      setTemporaryInputHighlight("startTime");
    } else {
      setIsPickupTimeCheck(true);
    }
    setIsStartTimeCheck(true);
    debugL > 1 && console.log("setIsStartTimeCheck(true)");
  }, [startTimeOptions, locationTimeSlotHours, day, timeSlotType, locationIndex, deliveryLocationIndex]) // fixes startTime
  
  useEffect(() => {
    const newDay = fixedDay();
    if(newDay) {
      setDay(newDay);
      setTemporaryInputHighlight("day");
    }
  }, [locationTimeSlots]); // fixes day

  useEffect(() => {
    const zip = cityZips[city];
    if(zip == "All75") {
      setCityZipOptions(parisZipOptions);
      setZipCode("75001");
    } else {
      setCityZipOptions([{label: zip, value: zip}]);
      setZipCode(zip);
    }
  }, [city]) // => update zips

  useEffect(() => {
    const zip = cityZips[city0];
    if(zip == "All75") {
      setCityZipOptions0(parisZipOptions);
      setZipCode0("75001");
    } else {
      setCityZipOptions0([{label: zip, value: zip}]);
      setZipCode0(zip);
    }
  }, [city0]) // => update zips

  useEffect(() => {
    
    const fetchAndSetOrder = async () => {

      if(!orderId) {
        resetForm();
        return;
      }    

      // console.log("orderId = "+orderId);

      const orderDoc = await db.collection('carts').doc(orderId).get();
      const order = orderDoc.data();

      if(order.retailerId !== retailerId) {
        // history.push("/orders");
        toggleDrawer(false, "", null, false)();
      }

      setCachedOrder(order);

      setOrderName(order.name ? order.name : 
        order.retailerOrderId ? order.retailerOrderId : "");

      if(!isTourMode) {
        setInvoiceUnits(order.invoiceUnits ?? 1);    
        setContainerCount1(order.containerCount1 ?? 0);    
        setContainerCount2(order.containerCount2 ?? 0);    
        setContainerCount3(order.containerCount3 ?? 0);    
        setContainerCount4(order.containerCount4 ?? 0);    
        setLooseWeight(order.looseWeight ?? "10");    
        setTemperatureRange(order.temperatureRange ?? "10-30");    
        setVoluminosity(order.voluminosity ?? 0);    
        setContainerReturn(order.containerReturn ?? 0);    
        setRetailerOrderType(order.retailerOrderType ?? "");    
        setWeight(order.weight);
        setCity(order.customerAddress.city);
        setAddress(order.customerAddress.address1);
        setZipCode(order.customerAddress.postcode);
        setCompany(order.customerAddress.company ? order.customerAddress.company : "");
        setFirstName((order.customerAddress.firstName ? order.customerAddress.firstName : 
            order.customerAddress.firstname ? order.customerAddress.firstname : "") +
            (order.customerAddress.lastName ? order.customerAddress.lastName : 
            order.customerAddress.lastname ? order.customerAddress.lastname : ""));
        // setLastName(order.customerAddress.lastName ? order.customerAddress.lastName : 
        //   order.customerAddress.lastname ? order.customerAddress.lastname : "");
        setInstructions(order.customerAddress.instructions ?? "");
        setPhoneNumber(order.phoneNumber ?? "");
        if(order.pickupAddress) {
          setCity0(order.pickupAddress.city);
          setAddress0(order.pickupAddress.address1);
          setZipCode0(order.pickupAddress.postcode);
          setCompany0(order.pickupAddress.company ? order.pickupAddress.company : "");
          setFirstName0(order.pickupAddress.firstName + (order.pickupAddress.lastName ? " "+order.pickupAddress.lastName : ""));
          // setLastName0(order.pickupAddress.lastName);
          setPhoneNumber0(order.pickupAddress.phoneNumber ?? "");
          setInstructions0(order.pickupAddress.instructions ?? "");
        }
        if (order.timeSlot) {
          const ts = order.timeSlot; 
          setTimeSlotType(order.timeSlotDuration ? "" + order.timeSlotDuration : "1");   
          // console.log("startTime to be set : " + (ts.toDate().getHours()));
          setStartTime("" + dateToDecimalHours(ts.toDate()));
          setPickupTime(order.pickupTime);
          setDay(ts.toDate());
        }    
        
        if(!isUpdate && !newOrderId) {
          setDeliveryNotePath("");
        } else {
          setDeliveryNotePath(order.deliveryNotePath);
        }

        setDefaultPickup(order.defaultPickup !== undefined ? order.defaultPickup : true);
      }

      // load state for managing the tour.
      if(isTourMode) {
        let actionPointIndex = 1;
        const orderActionPoints = [];
        while (order["actionPoint" + actionPointIndex]){
          orderActionPoints.push(order["actionPoint" + actionPointIndex]);
          actionPointIndex++;
        }

        setActionPoints(orderActionPoints);
        setTourDuration(order.tourDuration);
        setPointEtas(order.pointEtas);
  
        setStartHour(order.startHour);
        setStartMinute(order.startMinute);

        if (order.timeSlot) {
          const ts = order.timeSlot;
          setDay(ts.toDate());
        }    
      }
      
      
      setFreq(order.frequency !== undefined ? order.frequency : "unique");
      setRecDefReady(order.recDefReady ?? false);
      setRecDailyDays(order.recDailyDays ?? "1111111");

      setShippingPrice(order.shippingPrice !== undefined ? formatPrice(order.shippingPrice) : '-.--');
    }

    fetchAndSetOrder();

  }, [orderId]) // => update order data

  // TODO load deliveryLocationId
  useEffect(() => {
    if(cachedOrder && locations.length > 0) {
      const locationId = cachedOrder.locationId ?? retailerFallbackLocationId ?? "";
      const deliveryLocationId = cachedOrder.deliveryLocationId !== undefined ? cachedOrder.deliveryLocationId : "";
      for(let loc of locations) {
        if(loc.id === locationId) {
          setLocationIndex(loc.value);
        }
        if(loc.id === deliveryLocationId) {
          setDeliveryLocationIndex(loc.value);
        }
      } 
    }

  }, [cachedOrder, locations]); // => update locationIndex

  useEffect(() => {
    const fetchAndSetLocations = async () => {
      try {
        const newLocations = (await getLocations(retailerId))
          .map((loc, idx) => ({
            value: "" + idx,
            label: loc.address,
            id: loc.id,
            location: loc.data
          }));
        
        newLocations.push({value: "" + newLocations.length, label: "Hub Loberz", id:"HUB"});
        // TODO Name the id the following location EXTERNAL. Transform old ones when loading cachedOrder accordingly
        newLocations.push({value: "" + newLocations.length, label: "Autre adresse", id:""});
        setLocations(newLocations);
        setLocationIndex("0");
        setDeliveryLocationIndex("" + (newLocations.length-1));
      } catch(e) {
        debugL > 1 && console.log("error while loading locations");
        debugL > 1 && console.log(e.message);
        setLocations([]);
      }
    }
    
    setTsTypeOptions(tsTypeOptionsFull.filter( tsType => {
      if(["1","3"].includes(tsType.value)) {
        return true;
      }

      if ( !retailerData.timeSlotPermissions || !retailerData.timeSlotPermissions.includes(tsType.value) ) {
        return false;
      } else {
        return true;
      }
    }));
    
    let retailerCityOptions = parisCityOptions;
    if(retailerData.cityPermissions) {
      if (retailerData.cityPermissions.includes("zone2")){
        retailerCityOptions = retailerCityOptions.concat(zone2CityOptions)
      }
      if (retailerData.cityPermissions.includes("zone2B")){
        retailerCityOptions = retailerCityOptions.concat(zone2BCityOptions)
      }
      if (retailerData.cityPermissions.includes("zone3")){
        retailerCityOptions = retailerCityOptions.concat(zone3CityOptions)
      }
      for(let option of offZoneCityOptions) {
        if(option.retailerIds.includes(retailerId)) {
          retailerCityOptions.push(option);
        }
      }
    }
    console.log(retailerCityOptions);

    setCityOptions(retailerCityOptions);
    setCity("Paris");
    
    let retailerCityOptions0 = parisCityOptions;
    if(retailerData.pickupCityPermissions) {
      if (retailerData.pickupCityPermissions.includes("zone2")){
        retailerCityOptions0 = retailerCityOptions0.concat(zone2CityOptions)
      }
      if (retailerData.pickupCityPermissions.includes("zone2B")){
        retailerCityOptions0 = retailerCityOptions0.concat(zone2BCityOptions)
      }
      if (retailerData.pickupCityPermissions.includes("zone3")){
        retailerCityOptions0 = retailerCityOptions0.concat(zone3CityOptions)
      }
    }
    setCityOptions0(retailerCityOptions0);
    setCity0("Paris");
  
    fetchAndSetLocations();
    
  }, [retailerId]); // => update tsTypeOptions cityOptions then locations then locationIndex=0 

  useEffect(() => {
    updateAllTimeSlots(false);
  }, []); // => load all time slots and city

  // EVENT HANDLERS

  // parts of this function and rest api should be transformed into a single trigger onCartUpdate to paid
  const handleConfirm = async (priceOnly=false) => {
    setIsConfirmProcessing(true);
    // console.log("Add order started");
    
    try {
      let cart = null;
      let newRef = null;

      if(isTourMode) {
        // 1. Validation
        const isValid = actionPoints.every(p => p.address && p.serviceTime >= 5);
        if (!isValid) {
          enqueueSnackbar("Veuillez remplir toutes les adresses et un temps de service d'au moins 5 minutes.", { variant: 'error' });
          throw new Error("Invalid tour data");
        }

        // 2. Data Transformation for Firestore
        const actionPointsForFirestore = actionPoints.reduce((obj, point, index) => {
          const { id, ...rest } = point; // Exclude the React 'id' key
          obj[`actionPoint${index + 1}`] = rest;
          return obj;
        }, {});

        // 3. Build the cart INPUT object to send to the backend
        cart = {
          name: orderName,
          retailerId,
          isTourMode: true,
          timeSlot: timeSlotfromStartTime(),
          startHour,
          startMinute,
          ...actionPointsForFirestore
        }
      } else {
        let pn = phoneNumber; 
        if (pn.startsWith("0")) {
          pn = "+33" + pn.substr(1);
        }
  
  
        await validate();
  
        // MAIN INFO
        const locationId = locations[parseInt(locationIndex)].id;
        const deliveryLocationId = locations[parseInt(deliveryLocationIndex)].id;
  
        const name = orderName ? orderName : firstName;
        // const name = orderName ? orderName : firstName + lastName;
        // console.log("city");
        // console.log(city);
        let processedWeight = weight;
        if(hasInvoiceUnits && invoiceUnitsImplyWeight) {
          processedWeight = "" + Math.ceil(invoiceUnits * invoiceUnitsImplyWeight);
        } if (numberOfContainers > 0) {
          processedWeight = "" + (
            containerWeight1 * containerCount1 + 
            containerWeight2 * containerCount2 + 
            containerWeight3 * containerCount3 + 
            containerWeight4 * containerCount4 +
            parseInt(looseWeight) 
          );
        }
  
        cart = {
          name,
          invoiceUnits,
          containerCount1,
          containerCount2,
          containerCount3,
          containerCount4,
          looseWeight,
          temperatureRange,
          voluminosity,
          containerReturn,
          weight: processedWeight,        
          locationId,
          deliveryLocationId
        }
        
        // DELIVERTY NOTE
        if(deliveryNotePath && deliveryNotePath != "L'upload du bon de livraison a échoué") {
          cart.deliveryNotePath = deliveryNotePath;
        } else if(!(locations[locationIndex].id == "HUB") && !isDeliveryNoteMendatory) { 
          cart.deliveryNotePath = "";
        } else {
          cart.deliveryNotePath = "MISSING_PATH";
        }
  
        // TIME SLOT (and Duration)
        if(cart.orderStatus != "delivered") {
          const ts = timeSlotfromStartTime();
  
          cart.timeSlot = ts;
          cart.timeSlotDuration = timeSlotType;
  
          cart.pickupTime = pickupTime;
        }
  
        // PICKUP LOCATION (SET WHEN LOCATION ID="" or ="HUB")
        if(!locationId) {
          cart.pickupAddress = {
            company: company0,
            firstName: firstName0,
            // lastName: lastName0,
            address1: address0,
            postcode: zipCode0,
            city: city0,
            country: "FR",
            phoneNumber: phoneNumber0,
            instructions: instructions0
          };
          cart.defaultPickup = false;
        } else if(locationId == "HUB") {
          cart.pickupAddress = {
            company: "Hub Loberz",
            firstName: "",
            // lastName: lastName0,
            address1: "47, rue des Gravilliers",
            postcode: "75003",
            city: "Paris",
            country: "FR",
            phoneNumber: "",
            instructions: ""
          };
          cart.defaultPickup = false;
        } else {
          cart.defaultPickup = true;
          cart.pickupAddress = null;
        }
  
        // DELIVERY LOCATION (SET WHEN LOCATION ID="" or ="HUB")
        if(!deliveryLocationId) {
          cart.customerAddress = {
            company,
            firstName,
            // lastName,
            address1: address,
            postcode: zipCode,
            city: city,
            country: "FR",
            instructions,
            phoneNumber: pn
          };
          cart.phoneNumber = pn;
        } else if(deliveryLocationId == "HUB") {
          cart.customerAddress = {
            company: "Hub Loberz",
            firstName: "",
            // lastName: lastName0,
            address1: "47, rue des Gravilliers",
            postcode: "75003",
            city: "Paris",
            country: "FR",
            phoneNumber: "",
            instructions: ""
          };
          cart.phoneNumber = "";
        } else {
          cart.customerAddress = null;
        }
  
        // fill pickup and delivery addresses 
        await fillPickupAddress(cart, locationId);
        await fillDeliveryAddress(cart, deliveryLocationId);
      }

      // RECCURENCY
      cart.frequency = freq;
      if(freq === "daily") {
        cart.frequencyDays = 1;
        cart.recDailyDays = recDailyDays;
      }
      cart.recDefReady = recDefReady;
        
      // PRICING and/or ORDER SUBMISSION
      cart.pricingRequestDate = new Date();

      if(isUpdate) {
        cart.updatedBy = currentUser.email;
        await db.collection('carts').doc(orderId).update(cart); 
        if(priceOnly) {
          enqueueSnackbar("La commande a été mise à jour", { variant: 'info', autoHideDuration: 5000 });
        }
      } else if(newOrderId) { // the order has already submitted before (for picing for example)
        if(!priceOnly) {
          cart.orderStatus = "paid";
        }
        cart.updatedBy = currentUser.email;
        await db.collection('carts').doc(newOrderId).update(cart); 
      } else {
        cart.retailerId = retailerId;
        cart.creationDate = new Date();
        cart.retailerName = retailerData.name;
        cart.startPointId = retailerData.startPointId;
        cart.code = makeCode(4);

        if(priceOnly) {
          cart.orderStatus = "no_order";
        } else {
          cart.orderStatus = "paid"; // could be put to no_order then updated to paid to trigger an event cloud function
        }

        cart.createdBy = currentUser.email;
        cart.updatedBy = currentUser.email;
        newRef = await db.collection('carts').add(cart);              
      }      
      
      // get id to pull the cart and read price.
      let id = "NO_ID";
      if(orderId) {
        id = orderId;
      } else if (newOrderId) {
        id = newOrderId;
      } else if (newRef) {
        id = newRef.id;
      }

      // console.log(id);
       
      let pricedCart = null;
            
      if(priceOnly) {
        let nbPoints = 0;
        let nbTrials = 0;              
        do {
          setShippingPrice("." + ".".repeat(nbPoints));
          await delay(500);          
          debugL > 0 && console.log("nbTrials", nbTrials);
          if (nbPoints == 2) {
            nbTrials += 1;
            pricedCart = (await db.collection("carts").doc(id).get()).data();
            debugL > 0 && console.log("pricedCard", pricedCart);
          }
          nbPoints = (nbPoints + 1) % 3
        } while (
          (!pricedCart || !pricedCart.pricingDate || pricedCart.pricingDate.toDate().getTime() != pricedCart.pricingRequestDate.toDate().getTime()) &&
          nbTrials < 16
        )     
        // console.log(pricedCart);
  
        if (
          pricedCart &&
          pricedCart.shippingPrice > 0 && // TODO : not needed after the two added conditions below (to be removed) 
          pricedCart.pricingDate &&
          pricedCart.pricingDate.toDate().getTime() == cart.pricingRequestDate.getTime()
        ) {
          setShippingPrice(formatPrice(pricedCart.shippingPrice));
          if (isTourMode && pricedCart.tourDuration) {
            const totalMinutes = Math.round(pricedCart.tourDuration * 60);
            // setTourDuration(`${Math.floor(totalMinutes / 60)}h ${totalMinutes % 60}min`);
            setTourDuration(pricedCart.tourDuration);
            setPointEtas(pricedCart.pointEtas || []); // Expecting an array of "HH:mm" strings
          }
        } else {
          setShippingPrice('-.--');          
          if(isTourMode) {
             setTourDuration(null);
             setPointEtas([]);
          }
        }
      }
      
      if(newRef) {
        setNewOrderId(newRef.id);
      }
  
      if(!priceOnly) {
        debugL > 1 && console.log("YOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO")        
        setLastRefreshDate(new Date());
        toggleDrawer(false, "", null, false)();
      } else if(isUpdate) {
        setLastRefreshDate(new Date());
      }
      
    } 
    catch (e) {
      console.log("ERROR in : add order");
      console.log(e.message);
    }

    finally{
      // setDeliveryNoteUpload(null);  
      // setDeliveryNotePath("");      
      setIsConfirmProcessing(false);
    }
  }

  // RENDERING

  const numberOfContainers = retailerData.numberOfContainers;
  const containerTitle1  = retailerData.containerTitle;
  const containerTitle2  = retailerData.containerTitle2;
  const containerTitle3  = retailerData.containerTitle3;
  const containerTitle4  = retailerData.containerTitle4;
  const containerLiters1 = retailerData.containerLiters;
  const containerLiters2 = retailerData.containerLiters2;
  const containerLiters3 = retailerData.containerLiters3;
  const containerLiters4 = retailerData.containerLiters4;
  const containerWeight1 = Math.ceil(containerLiters1 / 5); 
  const containerWeight2 = Math.ceil(containerLiters2 / 5);
  const containerWeight3 = Math.ceil(containerLiters3 / 5);
  const containerWeight4 = Math.ceil(containerLiters4 / 5);


  const hasInvoiceUnits = retailerData.hasInvoiceUnits;
  const invoiceUnitsTitle = retailerData.invoiceUnitsTitle;
  const invoiceUnitsImplyWeight = retailerData.invoiceUnitsImplyWeight;
  const hasTemperatureRange = retailerData.hasTemperatureRange;  
  const hasVoluminosity = retailerData.hasVoluminosity;
  const hasContainerReturn = retailerData.hasContainerReturn;
  const weightPermissions = retailerData.weightPermissions;

  // console.log(timeSlots.map(ts => ts.startTime.toDate()));
  // console.log("minDate",!fullSupport && timeSlots[0] ? timeSlots[0].startTime.toDate() : new Date())
  // console.log("maxDate",timeSlots[0] ? timeSlots[timeSlots.length-1].startTime.toDate() : null)

  debugL > 1 && console.log(locations);
  debugL > 1 && console.log(deliveryLocationIndex);
  debugL > 1 && console.log(locations[parseInt(deliveryLocationIndex)])

  // if(locations && locations.length>0 && locationIndex) {
  //   console.log("debug1 "+(["dose.paris", "DRAFT"].includes(retailerId) && !locations[locationIndex].id == "HUB" && orderName.toLowerCase().includes("hub")));
  //   console.log(["dose.paris", "DRAFT"].includes(retailerId));
  //   console.log(locations[locationIndex].id != "HUB");
  //   console.log(locations[locationIndex].id);
  //   console.log(orderName.toLowerCase().includes("hub"));
  //   console.log(orderName.toLowerCase());
  // }

  let actualWeightOptions = weightOptions;
  if(!retailerData.numberOfContainers || retailerData.numberOfContainers == 0) {
    actualWeightOptions = weightOptions.filter(o => o.value != "0");
  }

  return (    
    <Drawer
      anchor="right"
      open={drawerState}
      onClose={toggleDrawer(false, "", null, false)}
      >
      <Container maxWidth={isMobile ? "xs" : "md"} sx={isMobile ? { m: 0, py : 2} : { m: 3}}>
        <SnackbarProvider />
        <Typography
            sx={{ mb: 3 }}
            variant="h4"
        >
              {drawerTitle}
        </Typography>     
        <form>
          <Grid container spacing={4} wrap="wrap">


            <OrderDescription {...{
              isTourMode, orderName, setOrderName, 
              hasTemperatureRange, temperatureRange, setTemperatureRange,temperatureRangeOptions, 
              hasVoluminosity, voluminosity, setVoluminosity, 
              hasContainerReturn, containerReturn, setContainerReturn,
              hasInvoiceUnits, invoiceUnitsTitle, invoiceUnitsImplyWeight, 
              invoiceUnits, setInvoiceUnits, weight, setWeight, actualWeightOptions, weightPermissions,

              numberOfContainers,
              containerTitle1, containerCount1, setContainerCount1,
              containerTitle2, containerCount2, setContainerCount2,
              containerTitle3, containerCount3, setContainerCount3,
              containerTitle4, containerCount4, setContainerCount4,
              looseWeight, setLooseWeight

            }} />


            {isTourMode ? (
              // --- NEW: TOUR MODE ROUTE UI ---
              <>
                <Grid item sm={12} xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography color="textPrimary" variant="h6">Itinéraire</Typography>
                    <IconButton onClick={addPoint} disabled={actionPoints.length >= 10} color="primary">
                      <Iconify icon="eva:plus-circle-outline" />
                    </IconButton>
                  </Box>
                </Grid>

                {actionPoints.map((point, index) => (
                  <React.Fragment key={point.id}>
                    <Grid item sm={12} xs={12}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                        <Typography variant="subtitle1" sx={{ flexGrow: 1 }}>{`Point ${index + 1}`}</Typography>
                        {actionPoints.length > 2 && (
                          <IconButton onClick={() => removePoint(index)} size="small" color="error">
                            <Iconify icon="eva:trash-2-outline" />
                          </IconButton>
                        )}
                      </Box>
                    </Grid>

                    <Grid item sm={6} xs={12}><TextField value={point.address} onChange={(e) => handlePointChange(index, 'address', e.target.value)} label="Numéro et nom de la rue" fullWidth required /></Grid>
                    <Grid item sm={4} xs={12}><SimpleSelect value={point.city} onChange={(e) => handlePointChange(index, 'city', e.target.value)} label="Ville" options={cityOptions} required /></Grid>
                    <Grid item sm={2} xs={12}><SimpleSelect value={point.zipCode} onChange={(e) => handlePointChange(index, 'zipCode', e.target.value)} label="Code postal" options={cityZipOptions} required /></Grid>
                    <Grid item sm={10} xs={12}><TextField value={point.instructions} onChange={(e) => handlePointChange(index, 'instructions', e.target.value)} label="Instructions pour ce point" fullWidth /></Grid>
                    <Grid item sm={2} xs={12}><TextField value={point.serviceTime} onChange={(e) => handlePointChange(index, 'serviceTime', e.target.value)} label="Temps de service" type="number" inputProps={{ min: "5" }} fullWidth required /></Grid>
                  </React.Fragment>
                ))}
              </>
            ) : (
              <>
                <Grid item sm={12} xs={12} > <Typography color="textPrimary" variant="h6">Expéditeur</Typography></Grid>          
                <Grid item sm={parseInt(locationIndex) == (locations.length-1) ? 6 : parseInt(locationIndex) == (locations.length-2) ? 12 : 11} xs={11} >
                  <SimpleSelect2
                    value={locationIndex}
                    onChange={handlerBy(setLocationIndex)}
                    label=""
                    options={locations}
                  />
                </Grid>            
                { parseInt(locationIndex) < (locations.length-2) ?          
                  <Grid item sm={1} xs={1} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <IconButton onClick={() => prefillPickupAddress()}  disabled={isRefreshTsProcessing || isConfirmProcessing }>
                      <Iconify icon={"tabler:edit"} style={{ color: isRefreshTsProcessing || isConfirmProcessing ? 'gray' : '#357be4' }}/>
                    </IconButton>
                  </Grid> : null
                }
                { locationIndex === "" + (locations.length-1) ?
                <>                                  
                  <Grid item sm={4} xs={12} >
                    <SimpleSelect 
                      value={city0}
                      onChange={handlerBy(setCity0)}
                      label="Ville"
                      options={cityOptions0}
                      // disabled
                      // disabled={cityOptions0.length==1}
                      required
                    />
                  </Grid>
                  <Grid item sm={2} xs={12} >
                    <SimpleSelect 
                      value={zipCode0}
                      onChange={handlerBy(setZipCode0)}
                      label="Code postal"
                      options={cityZipOptions0}
                      required
                    />
                  </Grid>
                  <Grid item sm={6} xs={12} >
                    <TextField
                      value={address0}
                      onChange={handlerBy(setAddress0)}
                      label="Numéro et nom de la rue" 
                      required
                      type="text"
                      variant="outlined" 
                      fullWidth
                    />
                  </Grid>                         
                  <Grid item sm={6} xs={12} >
                    <TextField
                      value={instructions0}
                      onChange={handlerBy(setInstructions0)}
                      label="Accès (ex: digicode, nom sur interphone)" 
                      type="text"
                      variant="outlined" 
                      fullWidth
                    />
                  </Grid>
                  <Grid item sm={4} xs={12} >
                    <TextField
                      value={company0}
                      onChange={handlerBy(setCompany0)}
                      label="Entreprise"
                      type="text"
                      variant="outlined" 
                      fullWidth
                    />
                  </Grid>
                  <Grid item sm={4} xs={12} >
                    <TextField
                      value={firstName0}
                      onChange={handlerBy(setFirstName0)}
                      label="Personne à contacter"
                      type="text"
                      variant="outlined" 
                      fullWidth
                    />
                  </Grid>
                  <Grid item sm={4} xs={12} >
                    <TextField
                      value={phoneNumber0}
                      onChange={handlerBy(setPhoneNumber0)}
                      label="Téléphone" 
                      required
                      type="text"
                      variant="outlined" 
                      fullWidth
                    />
                  </Grid>  
                </> : null }              
                { fullSupport || isDeliveryNoteMendatory || locationIndex === "" + (locations.length-2) ? <>
                  <Grid item sm={12} xs={12} sx={{ display: 'flex', justifyContent: 'start'}}>
                  {/* <Box sx={{ display: 'flex', justifyContent: 'start', pt: 3 }}> */}
                    <Box sx={{ display: 'flex', alignItems: "center", pr: 3}}>
                      <Button
                        variant="outlined"
                        component="label"
                        disabled={isUploadProcessing}                    
                      >
                        Bon de livraison
                        <input
                          type="file"
                          hidden                      
                          onChange={async (event) => {                        
                            uploadDeliveryNote(event.target.files[0]);
                          }}
                        />
                      </Button>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: "center", pl: 0 }}>
                      <Typography color="textPrimary" variant="p">
                        {deliveryNotePath ? deliveryNotePath : ""}
                      </Typography>
                    </Box>
                  {/* </Box>           */}
                  </Grid>
                </> : null }

                <Grid item sm={5} xs={12}>
                  {/* <Box sx={{ display: 'flex', alignItems: "center"}} > */}
                    <Typography color="textPrimary" variant="h6">
                      Destinataire
                    </Typography>                
                  {/* </Box> */}
                </Grid>
                <Grid item sm={2} xs={12} style={{ paddingTop: '0px', display: 'flex', justifyContent: 'center', alignItems: 'flex-end'}}>
                  {/* <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="top"
                  > */}
                    <IconButton onClick={() => swapPikcupAndDelivery()}  disabled={isRefreshTsProcessing || isConfirmProcessing || !cityOptions0.map(c=>c.value).includes(city)}>
                      <Iconify icon={"ic:round-swap-vert"} style={{ color: isRefreshTsProcessing || isConfirmProcessing || !cityOptions0.map(c=>c.value).includes(city) ? 'gray' : '#357be4' }}/>
                    </IconButton>
                  {/* </Box>               */}
                </Grid>
                <Grid item sm={5} xs={12}></Grid>
                <Grid item sm={parseInt(deliveryLocationIndex) == (locations.length-1) ? 6 : parseInt(deliveryLocationIndex) == (locations.length-2) ? 12 : 11} xs={11} >
                  <SimpleSelect2
                    value={deliveryLocationIndex}
                    onChange={handlerBy(setDeliveryLocationIndex)}
                    label=""
                    options={locations}
                  />
                </Grid>            
                { parseInt(deliveryLocationIndex) < (locations.length-2) ?          
                  <Grid item sm={1} xs={1} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <IconButton onClick={() => prefillDeliveryAddress()}  disabled={isRefreshTsProcessing || isConfirmProcessing }>
                      <Iconify icon={"tabler:edit"} style={{ color: isRefreshTsProcessing || isConfirmProcessing ? 'gray' : '#357be4' }}/>
                    </IconButton>
                  </Grid> : null
                }           
                { deliveryLocationIndex === "" + (locations.length-1) ?
                <>                                                                                  
                  <Grid item sm={4} xs={12} >
                    <SimpleSelect 
                      value={city}
                      onChange={handlerBy(setCity, null, (city) => {
                        if([
                          "Boulogne-Bilancourt", 
                          "Puteaux", 
                          "Courbevoie", 
                          "Asnières-sur-Seine", 
                          "Nanterre", 
                          "La-Garenne-Colombes", 
                          "Bois-Colombes",
                        ].includes(city)) {
                          enqueueSnackbar("Seuls les créneaux du matin sont disponibles pour la zone 3", { variant: 'info', autoHideDuration: 5000 });  
                        }

                        if([
                          "Colombes",
                          "Saint-Cloud",
                          "Rueil-Malmaison",
                        ].includes(city)) {
                          enqueueSnackbar("Les commandes en Hors Zone peuvent êtes livrées en J ou en J+1", { variant: 'info', autoHideDuration: 5000 });  
                        }
                      })}
                      label="Ville"
                      options={cityOptions}
                      required
                    />
                  </Grid>
                  <Grid item sm={2} xs={12} >
                    <SimpleSelect 
                      value={zipCode}
                      onChange={handlerBy(setZipCode)}
                      label="Code postal"
                      options={cityZipOptions}
                      required
                    />
                  </Grid>  
                  <Grid item sm={6} xs={12} >
                    <TextField
                      value={address}
                      onChange={handlerBy(setAddress)}
                      label="Numéro et nom de la rue" 
                      required
                      type="text"
                      variant="outlined" 
                      fullWidth
                    />
                  </Grid>            
                  <Grid item sm={6} xs={12} >
                    <TextField
                      value={instructions}
                      onChange={handlerBy(setInstructions)}
                      label="Accès (ex: digicode, nom sur interphone)" 
                      type="text"
                      variant="outlined" 
                      fullWidth
                    />
                  </Grid>
                  <Grid item sm={4} xs={12} >
                    <TextField
                      value={company}
                      onChange={handlerBy(setCompany)}
                      label="Entreprise"
                      type="text"
                      variant="outlined" 
                      fullWidth
                    />
                  </Grid>
                  <Grid item sm={4} xs={12} >
                    <TextField
                      value={firstName}
                      onChange={handlerBy(setFirstName)}
                      label="Personne à contacter"
                      type="text"
                      variant="outlined" 
                      fullWidth
                    />
                  </Grid>
                  <Grid item sm={4} xs={12} >
                    <TextField
                      value={phoneNumber}
                      onChange={handlerBy(setPhoneNumber)}
                      label="Téléphone" 
                      required
                      type="text"
                      variant="outlined" 
                      fullWidth
                    />
                  </Grid>
                </> : null }
              </>  
            )}

            <OrderTimeInfo {...{retailerOrderType, isTourMode, startHour, setStartHour, startMinute, setStartMinute, 
              handleTsRefresh, isRefreshTsProcessing, timeSlotType, setTimeSlotType, tsTypeOptions, 
              day, setDay, fullSupport, days, isStartTimeValid, startTime, setStartTime, startTimeOptions, freq, setFreq, 
              recDailyDays, setRecDailyDays, recDefReady, setRecDefReady, isPickupTimeValid, pickupTime, setPickupTime, pickupTimeOptions, 
              hightLightSx}}
            />

            {(["dose.paris", "DRAFT"].includes(retailerId) && locations && locations.length > 0 && locations[locationIndex].id == "HUB" && !orderName.toLowerCase().includes("hub")) && <Grid item md={12} sm={12} xs={12} >
              <Typography variant="subtitle1" sx={{color: "#D92D20"}}>
                {`Attention ! Cette commande est expédiée depuis le hub Loberz mais ne contient pas "HUB" dans Le nom`}
              </Typography>                  
            </Grid>}

            {(["dose.paris", "DRAFT"].includes(retailerId) && locations && locations.length > 0 && locations[locationIndex].id != "HUB" && orderName.toLowerCase().includes("hub")) && <Grid item md={12} sm={12} xs={12} >
              <Typography variant="subtitle1" sx={{color: "#D92D20"}}>
                {`Attention ! Cette commande n'est pas expédiée depuis le hub Loberz mais contient "HUB" dans Le nom`}
              </Typography>                  
            </Grid>}

            {(["dose.paris", "DRAFT"].includes(retailerId) && temperatureRange=="0-4" && !orderName.toLowerCase().includes("patisserie")) && <Grid item md={12} sm={12} xs={12} >
              <Typography variant="subtitle1" sx={{color: "#D92D20"}}>
                {`Attention ! Cette commande a l'option 0°C-4°C mais ne contient pas "PATISSERIE" dans Le nom`}
              </Typography>                  
            </Grid>}

            {(["dose.paris", "DRAFT"].includes(retailerId) && temperatureRange!="0-4" && orderName.toLowerCase().includes("patisserie")) && <Grid item md={12} sm={12} xs={12} >
              <Typography variant="subtitle1" sx={{color: "#D92D20"}}>
                {`Attention ! Cette commande n'a pas l'option 0°C-4°C mais contient "PATISSERIE" dans Le nom`}
              </Typography>                  
            </Grid>}

            {/* {isTourMode && tourDuration && (
              <Grid item sm={12} xs={12}>
                <Typography variant="h6">Estimation de l'itinéraire</Typography>
                <Typography variant="body1">Durée totale estimée : {tourDuration}</Typography>
                <Box component="ul" sx={{ pl: 2 }}>
                  {pointEtas.map((eta, index) => (
                    <Typography component="li" key={index}>
                      Point {index + 1} - ETA : <strong>{eta}</strong>
                    </Typography>
                  ))}
                </Box>
              </Grid>
            )} */}

            {isTourMode && tourDuration != null && (
              <Grid item sm={12} xs={12}>
                <Typography variant="h6">Estimation de l'itinéraire</Typography>
                <Typography variant="body1">
                  Durée totale estimée : <strong>
                    {(() => {
                      // Check if tourDuration is a number (decimal hours) and format it.
                      if (typeof tourDuration === 'number') {
                        const [hours, minutes] = decimalToHoursAndMinutes(tourDuration);
                        const paddedHours = String(hours).padStart(2, '0');
                        const paddedMinutes = String(minutes).padStart(2, '0');
                        return `${paddedHours}:${paddedMinutes}`;
                      }
                      // Fallback for any pre-formatted strings
                      return tourDuration;
                    })()}
                  </strong>
                </Typography>
                <Box component="ul" sx={{ pl: 2, mt: 1 }}>
                  {pointEtas.map((eta, index) => (
                    <Typography component="li" key={index}>
                      Point {index + 1} - ETA : <strong>{formatEtaRange(eta)}</strong>
                    </Typography>
                  ))}
                </Box>
              </Grid>
            )}

            <Grid item sm={12} xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', alignItems: "center", pr: isMobile ? 0 : 3}}>
                <Typography color="textPrimary" variant="h6">
                  {"Prix : " + shippingPrice}
                </Typography>
                <Box pr={2}>
                </Box>
                <IconButton onClick={() => handleConfirm(true)} disabled={isConfirmProcessing}>
                  <Iconify icon={"fluent:calculator-arrow-clockwise-24-regular"} style={{ color: isConfirmProcessing ? 'gray' : '#357be4' }}/>
                </IconButton>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', pl: isMobile ? 0 : 3 }}>
                <Button color="primary" variant="outlined" onClick={toggleDrawer(false, "", null, false)}>
                  Annuler
                </Button>
                <Box pr={2}>
                </Box>
                <Button color="primary" 
                    variant="contained" 
                    disabled={
                      locations.length>0 && parseInt(deliveryLocationIndex) >= 0 && locations[parseInt(deliveryLocationIndex)].id == "" && address == "" && !isTourMode ||                            
                      locations.length>0 && parseInt(locationIndex) >= 0 && locations[parseInt(locationIndex)].id == "" && address0 == "" && !isTourMode ||
                      startTime == "" ||
                      isConfirmProcessing ||                             
                      (
                        (
                          isDeliveryNoteMendatory 
                          || (
                            locations && 
                            locations.length > 0 && 
                            locations[locationIndex] && 
                            locations[locationIndex].id == "HUB" &&
                            retailerData.isDeliveryNoteMendatoryForHub
                          )
                        ) && 
                        (!deliveryNotePath || deliveryNotePath == "L'upload du bon de livraison a échoué")
                      )
                    } 
                    onClick={() => handleConfirm()}>
                  Confirmer
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Container>
    </Drawer>
  );
};

OrderCard.whyDidYouRender = true;

export default OrderCard;
